import { RegistrationCommitteeItem } from "./models";

export function calculateItemCountsForCategoryInMode(
  category: RegistrationCommitteeItem[][],
  mode: "enter-committee-decisions" | "review-final-reports"
) {
  const counts = category.reduce(
    (sums, items) => ({
      totalItems: sums.totalItems + items.length,
      enterDecisionsItems: sums.enterDecisionsItems + items.filter((item) => !item.isFinalReportSentForReview).length,
      reviewFinalDecisionsItems:
        sums.reviewFinalDecisionsItems + items.filter((item) => item.isFinalReportSentForReview && !item.isCompleted).length,
      alreadyCompletedItems: sums.alreadyCompletedItems + items.filter((item) => item.isCompleted).length
    }),
    { totalItems: 0, enterDecisionsItems: 0, reviewFinalDecisionsItems: 0, alreadyCompletedItems: 0 }
  );
  const { actionableCountAndDescription, notYetHereCountAndDescription, alreadyCompletedCountAndDescription } =
    mode === "enter-committee-decisions"
      ? {
          actionableCountAndDescription: `${counts.enterDecisionsItems} to release`,
          notYetHereCountAndDescription: null,
          alreadyCompletedCountAndDescription:
            counts.reviewFinalDecisionsItems + counts.alreadyCompletedItems > 0
              ? `${counts.reviewFinalDecisionsItems + counts.alreadyCompletedItems} already released`
              : null
        }
      : {
          actionableCountAndDescription: `${counts.reviewFinalDecisionsItems} to approve`,
          notYetHereCountAndDescription: counts.enterDecisionsItems ? `${counts.enterDecisionsItems} not yet released` : null,
          alreadyCompletedCountAndDescription: counts.alreadyCompletedItems ? `${counts.alreadyCompletedItems} already approved` : null
        };
  const othersCountAndDescription =
    alreadyCompletedCountAndDescription || notYetHereCountAndDescription
      ? `(${alreadyCompletedCountAndDescription ?? ""}${alreadyCompletedCountAndDescription && notYetHereCountAndDescription ? ", " : ""}${
          notYetHereCountAndDescription ?? ""
        })`
      : "";
  return {
    counts: counts,
    descriptions: {
      actionable: actionableCountAndDescription,
      notYetHere: notYetHereCountAndDescription,
      alreadyCompleted: alreadyCompletedCountAndDescription,
      formattedNonActionable: othersCountAndDescription
    }
  };
}
